module.exports = __webpack_public_path__ + "img/csv.7353013d.svg";